module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("kl0sR"))).then(() => parcelRequire('43EA6'));